import React, { useState } from 'react';
import styles from './upsell.module.scss';
import cn from 'classnames';
import profile from '@assets/images/profile.png';
import { LABEL } from '../../veriables';

const Upsell = (props) => {
  const [add, setAdd] = useState(false);
  return (
    <div className="col-12 h-100">
      <div className="h-10 fs-20 text-primary od-text-primary row align-items-center justify-content-center">
        {LABEL().MAY_WE_SUGGEST}
      </div>
      <div className="h-80 overflowY">
        <div className={cn('d-flex p-10 justify-content-between flex-row mb-10 od-container-card-background od-container-card-border', styles.cardBox)}>
          <div className={cn(false ? 'd-none' : 'col-3 col-lg-3 p-0 d-flex justify-content-center align-items-center')}>
            <img src={profile} alt=""
            />
          </div>
          <div className={cn((false) ? 'col-12 px-0' : 'col-9 col-lg-9 p-0')}>
            <div className={cn('p-2', false ? 'float-left' : '')}>
              <div className={cn('fw-600 d-flex flex-row justify-content-between px-2')}>
                <div className="fs-12">Dessert</div>
              </div>
            </div>
            <div className={cn(
              'd-flex justify-content-between p-2 fs-12',
            )}>
              <button type="submit" className="btn35 w-40 btn-primary btn-ripple od-btn-primary p-0 fs-14" onClick={() => setAdd(!add)}>{add ? LABEL().REFILL_REMOVE : LABEL().ADD_TO_BAG }</button>
              <div className={cn(true ? 'ml-3 text-right' : 'ml-auto text-right')}>
                {LABEL().CURRENCY_SYMBOL}{10}
              </div>
            </div>
          </div>
        </div>
        <div className={cn('d-flex p-10 justify-content-between flex-row mb-10 od-container-card-background od-container-card-border', styles.cardBox)}>
          <div className={cn(false ? 'd-none' : 'col-3 col-lg-3 p-0 d-flex justify-content-center align-items-center')}>
            <img src={profile} alt=""
            />
          </div>
          <div className={cn((false) ? 'col-12 px-0' : 'col-9 col-lg-9 p-0')}>
            <div className={cn('p-2', false ? 'float-left' : '')}>
              <div className={cn('fw-600 d-flex flex-row justify-content-between px-2')}>
                <div className="fs-12">Dessert</div>
              </div>
            </div>
            <div className={cn(
              'd-flex justify-content-between p-2 fs-12',
            )}>
              <button type="submit" className="btn35 w-40 btn-primary btn-ripple od-btn-primary p-0 fs-14" onClick={() => setAdd(!add)}>{add ? LABEL().REFILL_REMOVE : LABEL().ADD_TO_BAG }</button>
              <div className={cn(true ? 'ml-3 text-right' : 'ml-auto text-right')}>
                {LABEL().CURRENCY_SYMBOL}{10}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={cn('h-10 w-100 row align-items-center justify-content-center', styles.kioskBoxShadow)}> 
        <div className="col-12 d-flex my-2">
          <div className="col-6 text-center">
            <button className={cn('btn btn100 btn-primary btn-ripple od-btn-primary shadow-none border-0 fw-700 w-100 fs-20')} style={{ height: '5vh' }} type="button" onClick={props.handleCloseButton}>
              {LABEL().CLOSE}
            </button>
          </div>
          <div className="col-6 text-center">
            <button className={cn('btn btn100 btn-primary btn-ripple od-btn-primary shadow-none border-0 fw-700 w-100 fs-20')} style={{ height: '5vh' }} type="button" onClick={() => props.goToCart()}>
              {LABEL().NEXT}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Upsell;
